
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/willscenter",
      function () {
        return require("private-next-pages/willscenter.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/willscenter"])
      });
    }
  